import { render, staticRenderFns } from "./customer_posts.vue?vue&type=template&id=28fd7f69&scoped=true&"
import script from "./customer_posts.vue?vue&type=script&lang=js&"
export * from "./customer_posts.vue?vue&type=script&lang=js&"
import style0 from "./customer_posts.vue?vue&type=style&index=0&id=28fd7f69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd7f69",
  null
  
)

export default component.exports